const appid = 'wx8f1215d86965dac0'
const bxjsAppid = 'wxaa99063c0fc4174c'
const ggbAppid = 'wx0ba2f2d7bea88418'
const mapAppid = 'wx99f5879c3eef3014'

function getAppId() {
  const host = window.location.origin
  if (host.indexOf('bxjs') > -1) return bxjsAppid
  if (host.indexOf('irrigate') > -1) return ggbAppid
  if (host.indexOf('map.ascod.cn') > -1) return mapAppid

  return appid
}

export default {
  appid,
  bxjsAppid,
  getAppId
}
